export default __webpack_public_path__ + "static/media/pdf.f2ba9024.svg";